import axios from "axios";

const baseDomain =
	"https://firestore.googleapis.com/v1/projects/mojibake-backend/databases/(default)/documents";
const baseURL = `${baseDomain}`;

export default axios.create({
	baseURL,
});
